/**
 * hr-cart-add.js — lightweight AJAX add-to-cart for HR product cards.
 *
 * Self-contained on purpose: the custom hr-header has no reactive cart UI
 * (no <cart-icon>/<cart-drawer-component>), so instead of porting Horizon's
 * cart drawer (which conflicts with the custom header), we intercept the
 * card form submit, add via the Cart AJAX API, then bump the header count and
 * give button feedback. Forms keep action/method, so this degrades to a native
 * /cart/add POST if the script fails to load.
 *
 * One delegated listener on document — safe to load once per page.
 */
(function () {
  var RESET_DELAY = 1500;

  /** Update (or create/remove) the header cart count badge. */
  function updateCartCount(count) {
    document.querySelectorAll('.hr-nav__cart').forEach(function (cartEl) {
      var badge = cartEl.querySelector('.hr-nav__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'hr-nav__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          cartEl.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-hr-cart-add]');
    if (!form) return;

    event.preventDefault();
    if (form.dataset.busy === 'true') return;

    var button = form.querySelector('[data-hr-cart-label]');
    var variantId = form.dataset.variantId;
    if (!variantId) {
      form.submit(); // fall back to native POST
      return;
    }

    // Quantity and selling plan come off the form, not the dataset: product
    // cards post a hidden quantity=1 and no plan, while the Loravey PDP hero
    // carries a real stepper and a `selling_plan` input the plan radios write
    // to. Reading them here is what keeps a "Subscribe & Save" pick from
    // silently adding a one-time line item.
    var quantityField = form.querySelector('[name="quantity"]');
    var sellingPlanField = form.querySelector('[name="selling_plan"]');
    var payload = {
      id: Number(variantId),
      quantity: Number(quantityField && quantityField.value) || 1,
    };
    if (sellingPlanField && sellingPlanField.value) {
      payload.selling_plan = Number(sellingPlanField.value);
    }

    // Icon-only buttons (data-hr-cart-icon) keep their glyph: signal feedback
    // via data-state alone and never touch textContent (which would wipe the SVG).
    var isIcon = button ? button.hasAttribute('data-hr-cart-icon') : false;
    var originalLabel = button ? button.textContent : '';
    form.dataset.busy = 'true';
    if (button) {
      button.disabled = true;
      button.dataset.state = 'loading';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (button) {
          button.dataset.state = 'added';
          if (!isIcon) button.textContent = '✓ Added';
        }
      })
      .catch(function () {
        if (button) {
          button.dataset.state = 'error';
          if (!isIcon) button.textContent = 'Try again';
        }
      })
      .finally(function () {
        setTimeout(function () {
          form.dataset.busy = 'false';
          if (button) {
            button.disabled = false;
            button.removeAttribute('data-state');
            if (!isIcon) button.textContent = originalLabel;
          }
        }, RESET_DELAY);
      });
  });
})();
